import fetchHandler from '../../utilities/fetchHandler';
import actions from './signupActionTypes';

export const registerUser = (data) => {
    return {
        type: actions.GET_MY_ACTIVITY_LOGS,
        payload: data,
    };
};

export const setStepNumber = (step) => {
    return { type: actions.SET_STEP_NUMBER, payload: step };
};

export const setBusinessMailError = (value) => {
    return { type: actions.BUSINESS_MAIL_ERROR, payload: value };
};

export const configureDomainRequirement = (data) => {
    return { type: actions.CONFIGURE_DOMAIN_REQUIREMENT, payload: data };
};

export const configureMailRequirement = (data) => {
    return { type: actions.CONFIGURE_MAIL_REQUIREMENT, payload: data };
};

export const setPassword = (data) => {
    return { type: actions.SET_PASSWORD, payload: data };
};

export const setBusinessMailVerifyError = (data) => {
    return { type: actions.BUSINESS_MAIL_VERIFY_ERROR, payload: data };
};

export const getStateList = (countryCode, ourRequest = null) => {
    const fetchOptions = {
        url: `/api/registration/get-states/${countryCode}`,
        method: 'GET',
        shouldDispatch: true,
        actionType: actions.SET_STATE_OPTIONS,
        contentType: 'application/json',
        // cancelToken: ourRequest,
    };
    return fetchHandler(fetchOptions);
};

export const signUpAttempt = (formData) => {
    const fetchOptions = {
        url: `/api/registration/signup`,
        method: 'POST',
        body: JSON.stringify(formData),
        shouldDispatch: false,
        contentType: 'application/json',
    };
    return fetchHandler(fetchOptions);
};

export const verifyOTPRequest = (formData) => {
    const fetchOptions = {
        url: `/api/registration/validate-mail`,
        method: 'POST',
        body: JSON.stringify(formData),
        shouldDispatch: false,
        contentType: 'application/json',
    };
    return fetchHandler(fetchOptions);
};

export const trialSignupRequest = (formData) => {
    const fetchOptions = {
        url: `/api/registration/trial-signup`,
        method: 'POST',
        body: JSON.stringify(formData),
        shouldDispatch: true,
        actionType: actions.TRIAL_SAVE,
        contentType: 'application/json',
    };
    return fetchHandler(fetchOptions);
};

export const trialSignupVerify = (formData) => {
    const fetchOptions = {
        url: `/api/registration/validate-trial-signup`,
        method: 'POST',
        body: JSON.stringify(formData),
        shouldDispatch: false,
        contentType: 'application/json',
    };
    return fetchHandler(fetchOptions);
};
export const resendOTPRequest = (formData) => {
    const fetchOptions = {
        url: `/api/registration/resend-otp`,
        method: 'POST',
        body: JSON.stringify(formData),
        shouldDispatch: false,
        contentType: 'application/json',
    };
    return fetchHandler(fetchOptions);
};
export const updateValidationEmail = (formData) => {
    const fetchOptions = {
        url: `/api/registration/update-mail`,
        method: 'PUT',
        body: JSON.stringify(formData),
        shouldDispatch: true,
        actionType: actions.UPDATE_BASIC_DETAILS_EMAIL,
        contentType: 'application/json',
    };
    return fetchHandler(fetchOptions);
};

export const setSignUpBasicData = (data) => {
    return { type: actions.SET_FIRST_FORM_DATA, payload: data };
};

export const setOTPVerified = (data) => {
    return { type: actions.SET_OTP_VERIFIED, payload: data };
};
export const saveGetDomainPage = (data) => {
    return { type: actions.SAVE_GET_DOMAIN_DATA, payload: data };
};
export const saveDomainDetailsPage = (data) => {
    return { type: actions.SAVE_DOMAIN_DETAILS, payload: data };
};
export const savePlanSelection = (data) => {
    return { type: actions.SAVE_PLAN_DETAILS, payload: data };
};

export const processCard = (data) => {
    return { type: actions.PROCESS_CARD, payload: data };
};
export const updateBusinessEmail = (data) => {
    return { type: actions.BUSINESS_EMAIL, payload: data };
};

export const setGetDomainError = (res) => {
    return { type: actions.SET_GET_DOMAIN_ERROR, payload: res };
};

export const setStripeErrorMessage = (res) => {
    return { type: actions.SET_STRIPE_ERROR, payload: res };
};

export const setBusinessMailVerifed = (res) => {
    return { type: actions.BUSINESS_MAIL_VERIFY, payload: res };
};

export const setMailPasswordError = (res) => {
    return { type: actions.SET_EMAIL_PASSWORD_ERROR, payload: res };
};

export const getPricingDetails = () => {
    const fetchOptions = {
        url: `/api/registration/pricing`,
        method: 'GET',
        shouldDispatch: true,
        actionType: actions.GET_PRICING_DETAILS,
        contentType: 'application/json',
    };
    return fetchHandler(fetchOptions);
};
export const getDomainAvailability = (domain, formId) => {
    const fetchOptions = {
        url: `/api/registration/domain/find/${domain}/${formId}`,
        method: 'GET',
        shouldDispatch: true,
        actionType: actions.SET_DOMAIN_SUGGESTIONS,
        contentType: 'application/json',
    };
    return fetchHandler(fetchOptions);
};

export const sendBuisinessVerificationMail = (formData) => {
    const fetchOptions = {
        url: `/api/registration/send-business-verification-code`,
        method: 'POST',
        shouldDispatch: false,
        body: JSON.stringify(formData),
        contentType: 'application/json',
    };
    return fetchHandler(fetchOptions);
};

export const validateBuisinessVerificationMail = (formData) => {
    const fetchOptions = {
        url: `/api/registration/validate-business-mail`,
        method: 'POST',
        shouldDispatch: false,
        body: JSON.stringify(formData),
        contentType: 'application/json',
    };
    return fetchHandler(fetchOptions);
};

export const buyInfince = (formData, formId) => {
    const fetchOptions = {
        url: `/api/registration/complete/${formId}`,
        method: 'POST',
        shouldDispatch: false,
        body: JSON.stringify(formData),
        contentType: 'application/json',
    };
    return fetchHandler(fetchOptions);
};

export const fetchFormData = (formID, token) => {
    const fetchOptions = {
        url: `/api/registration/form-data/${formID}/${token}`,
        method: 'GET',
        shouldDispatch: false,
        contentType: 'application/json',
    };
    return fetchHandler(fetchOptions);
};

export const checkDomainBlacklisted = (formData) => {
    const fetchOptions = {
        url: `/api/registration/check-domain-valid`,
        method: 'POST',
        shouldDispatch: false,
        body: JSON.stringify(formData),
        contentType: 'application/json',
    };
    return fetchHandler(fetchOptions);
};

export const saveTempUrl = (data) => {
    return { type: actions.INFINCE_URL, payload: data };
};

export const clearStore = () => {
    return { type: actions.CLEAR, payload: null };
};

export const getDomainStatus = (domain,formID) => {
    const fetchOptions = {
        url: `/api/registration/domain/check-registered-status/${domain}/${formID}`,
        method: 'GET',
        shouldDispatch: true,
        actionType: actions.REGISTERED_DOMAIN_STATUS,
        contentType: 'application/json',
    };
    
    return fetchHandler(fetchOptions);
};
export const resendBusinessOTPRequest = (formData) => {
    const fetchOptions = {
        url: `/api/registration/resend-business-otp`,
        method: 'POST',
        body: JSON.stringify(formData),
        shouldDispatch: false,
        contentType: 'application/json',
    };
    return fetchHandler(fetchOptions);
};

export const trackEvent = (trackerEndPointId, params) => {
    return (dispatch) => {
        const fetchOptions = {
            url: `/api/track`,
            method: 'POST',
            body: JSON.stringify({
                ...params,
                endpointId: trackerEndPointId,
            }),
            shouldDispatch: false,
            contentType: 'application/json',
        };
        return dispatch(fetchHandler(fetchOptions));
    }
}